module.exports = "/_next/static/images/30ae7f836a4afb1eb2ace49303b60926-calendar-icon.svg";